import classNames from 'classnames';
import React from 'react';
import { useMatchMedia } from '@udemy/hooks';
import { Button, Picture } from '@udemy/react-core-components';
import { ContentGrid, ContentGridItem } from '@udemy/react-layout-components';
import { safelySetInnerHTML } from '@udemy/shared-utils';
import { tokens } from '@udemy/styles';
import styles from "./slim-hero-banner-slide.module.css";
export const SlimHeroBannerSlide = ({
  button1Href,
  button1OnClick,
  button1Target = '_self',
  button1Text,
  button1TextResponsive,
  button2Href,
  button2OnClick,
  button2Target = '_blank',
  button2Text,
  button2TextResponsive,
  className,
  image,
  imageResponsive,
  subtitle,
  subtitleOnClick,
  title,
  typography,
  url,
  urlOnClick
}) => {
  var _typography$title, _typography$subtitle;
  const isMobile = useMatchMedia('sm-max');
  const renderBannerImage = () => {
    const imageWideSource = {
      srcSet: imageResponsive.src,
      width: imageResponsive.width,
      height: imageResponsive.height,
      media: `(max-width: ${tokens['breakpoint-sm-max']})`
    };
    const bannerImage = /*#__PURE__*/React.createElement(Picture, Object.assign({}, image, {
      sources: [imageWideSource],
      className: styles['foreground-image']
    }));
    const isImageClickableLink = Boolean(url && (!button1Href || !button1Text));
    if (isImageClickableLink) {
      return /*#__PURE__*/React.createElement("a", {
        href: url,
        onClick: e => urlOnClick === null || urlOnClick === void 0 ? void 0 : urlOnClick(e, 'slide')
      }, bannerImage);
    }
    return bannerImage;
  };
  const firstButtonText = isMobile && button1TextResponsive ? button1TextResponsive : button1Text;
  const secondButtonText = isMobile && button2TextResponsive ? button2TextResponsive : button2Text;
  return /*#__PURE__*/React.createElement(ContentGrid, {
    className: classNames(styles.slide, className)
  }, /*#__PURE__*/React.createElement(ContentGridItem, {
    defaultColumn: "1 / span 2",
    mdColumn: "2 / span 5",
    lgColumn: "2 / span 4",
    className: styles['content-box']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['text-container']
  }, /*#__PURE__*/React.createElement("h1", Object.assign({
    className: classNames('ud-heading-sm', {
      'ud-heading-xxl': !isMobile
    }, (_typography$title = typography === null || typography === void 0 ? void 0 : typography.title) !== null && _typography$title !== void 0 ? _typography$title : '')
  }, safelySetInnerHTML({
    descriptionOfCaller: 'banner:title',
    html: title,
    domPurifyConfig: {
      ADD_ATTR: ['target']
    }
  }))), /*#__PURE__*/React.createElement("p", Object.assign({
    onClick: e => subtitleOnClick === null || subtitleOnClick === void 0 ? void 0 : subtitleOnClick(e, 'text'),
    className: classNames('ud-text-xs', {
      'ud-text-lg': !isMobile
    }, (_typography$subtitle = typography === null || typography === void 0 ? void 0 : typography.subtitle) !== null && _typography$subtitle !== void 0 ? _typography$subtitle : '')
  }, safelySetInnerHTML({
    descriptionOfCaller: 'banner:subtitle',
    html: subtitle,
    domPurifyConfig: {
      ADD_ATTR: ['target']
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles['cta-buttons-container']
  }, button1Href && firstButtonText && /*#__PURE__*/React.createElement(Button, Object.assign({
    id: "banner-cta-primary",
    udStyle: "primary",
    size: isMobile ? 'xsmall' : 'large',
    componentClass: "a",
    href: button1Href,
    onClick: button1OnClick,
    target: button1Target,
    className: styles['cta-1']
  }, button1Target === '_blank' && {
    rel: 'noopener'
  }), firstButtonText), button2Href && secondButtonText && /*#__PURE__*/React.createElement(Button, Object.assign({
    id: "banner-cta-secondary",
    udStyle: "secondary",
    size: isMobile ? 'xsmall' : 'large',
    componentClass: "a",
    href: button2Href,
    onClick: button2OnClick,
    target: button2Target,
    className: styles['cta-2']
  }, button2Target === '_blank' && {
    rel: 'noopener'
  }), secondButtonText))), /*#__PURE__*/React.createElement("div", {
    className: styles['image-container']
  }, renderBannerImage()));
};
//# sourceMappingURL=slim-hero-banner-slide.react-component.js.map